import React, { Component,Fragment } from "react";
import "./aboutApp.css";
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";

export default class aboutUs extends Component {

    render() {
        return (
            <Fragment>
                <Header />
                <section className="container about">
                    <div className="row">
                        <figure className="figure">
                            <div className="img-abouecomany">
                                <img src={require('../../assets/images/havayar/havayarBlack.jpg')} className="figure-img img-fluid " alt="..." />
                            </div>
                            <figcaption className="figure-caption about-info">
                                <h1>آینده نیازمند نوآوری است</h1>
                                <p className="lead">
                                    با اپلیکیشن هوایار می توانید برخی از خدماتی که از شرکت هوایار دریافت می کنید را راحت تر،با سرعت بیشتر و با کیفیت دریافت نمایید.نسخه اول اپلیکیشن در تلاش است از طریق تعامل با کاربران و مشتریان دسترسی به محصولات و خدمات هوایار را تسهیل کرده و با دریافت نظرات کاربران در نسخه های بعد، اپلیکیشن را توسعه داده و به روز نماید.
                                </p>
                            </figcaption>
                        </figure>
                    </div>
                </section>
                <Footer />
            </Fragment>
        );
    }
}
